import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const DASFAQ = () => {
  return (
    <section id="faq" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-black mb-4">
            Häufige Fragen
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            <AccordionItem value="age-license">
              <AccordionTrigger className="text-left font-heading font-semibold">
                Welches Alter und welcher Führerschein wird benötigt?
              </AccordionTrigger>
              <AccordionContent className="text-gray-700">
                Sie müssen mindestens 18 Jahre alt sein und einen gültigen Schweizer Führerschein 
                (oder gleichwertigen EU-Führerschein) besitzen. Der Führerschein muss seit mindestens 
                1 Jahr gültig sein.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="payment-deposit">
              <AccordionTrigger className="text-left font-heading font-semibold">
                Wie funktioniert die Zahlung und Kaution?
              </AccordionTrigger>
              <AccordionContent className="text-gray-700">
                Barzahlung ist kostenfrei. Bei Kartenzahlung fällt eine Gebühr von CHF 5.- an. 
                Die Kaution von CHF 300.- wird bei Abholung fällig und bei ordnungsgemässer 
                Rückgabe vollständig zurückerstattet.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="fuel-km">
              <AccordionTrigger className="text-left font-heading font-semibold">
                Wie funktioniert die Tankregelung und Kilometerbegrenzung?
              </AccordionTrigger>
              <AccordionContent className="text-gray-700">
                Es gilt die Voll-zu-voll Tankregelung: Sie erhalten das Fahrzeug vollgetankt und 
                geben es vollgetankt zurück. Alle Fahrzeuge haben unbegrenzte Kilometer – Sie können 
                so viel fahren wie Sie möchten.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="additional-driver">
              <AccordionTrigger className="text-left font-heading font-semibold">
                Kann ein zusätzlicher Fahrer das Fahrzeug nutzen?
              </AccordionTrigger>
              <AccordionContent className="text-gray-700">
                Ja, zusätzliche Fahrer können eingetragen werden. Bitte geben Sie dies bei der 
                Buchung an. Auch der zusätzliche Fahrer muss die Alters- und Führerschein-Anforderungen 
                erfüllen.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="abroad">
              <AccordionTrigger className="text-left font-heading font-semibold">
                Kann ich mit dem Fahrzeug ins Ausland fahren?
              </AccordionTrigger>
              <AccordionContent className="text-gray-700">
                Ja, Grenzübertritte sind gegen einen Aufpreis von CHF 50.- möglich. Bitte geben Sie 
                dies unbedingt bei der Buchung an, damit die entsprechenden Versicherungsdokumente 
                vorbereitet werden können.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="cancellation">
              <AccordionTrigger className="text-left font-heading font-semibold">
                Wie kann ich eine Buchung stornieren?
              </AccordionTrigger>
              <AccordionContent className="text-gray-700">
                Stornierungen sind bis 24 Stunden vor Mietbeginn kostenlos möglich. 
                Kontaktieren Sie uns einfach über WhatsApp oder telefonisch.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="damages">
              <AccordionTrigger className="text-left font-heading font-semibold">
                Was passiert bei Schäden am Fahrzeug?
              </AccordionTrigger>
              <AccordionContent className="text-gray-700">
                Bei Übergabe und Rückgabe wird ein detailliertes Übergabeformular ausgefüllt. 
                Alle Fahrzeuge sind vollkasko- und haftpflichtversichert mit einem Selbstbehalt 
                von CHF 1'000.- im Schadensfall. Bitte melden Sie Schäden umgehend.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="delivery">
              <AccordionTrigger className="text-left font-heading font-semibold">
                Bieten Sie einen Lieferservice an?
              </AccordionTrigger>
              <AccordionContent className="text-gray-700">
                Ja, auf Wunsch können wir Ihr Mietfahrzeug gegen einen kleinen Aufpreis direkt zu 
                Ihnen liefern. Die Kosten richten sich nach der Entfernung und können individuell 
                mit uns vereinbart werden. Kontaktieren Sie uns einfach bei der Buchung.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </section>
  );
};
